/**
 * Group API Module
 * Central export point for group management functionality
 */

// === MAIN API FUNCTIONS ===
export * from './api';

// === AUTH UTILITIES ===
export {
  getAuthConfigFromStore,
  isAuthConfigured,
  isAuthConfigValid,
  getAuthHeaders
} from '../auth/authUtils';

// === TYPE EXPORTS ===
export type {
  AddGroupParams,
  AddGroupResponse,
  GetGroupListParams,
  GetGroupListResponse,
  DeleteGroupParams,
  DeleteGroupResponse,
  RenameGroupParams,
  RenameGroupResponse,
  GroupRenameItem,
  AssignSubMasterToGroupParams,
  AssignSubMasterToGroupResponse,
  AddDevicesToGroupParams,
  AddDevicesToGroupResponse,
  DeviceGroupAssignment,
  GroupListItem,
  SubMasterInfo,
  GroupData,
  GetGroupDevicesParams,
  GetGroupDevicesResponse,
  GroupDashcamsItem,
  GroupAllocationDevice,
  GroupAllocationUser,
  AssignUserToDeviceParams,
  AssignUserToDeviceResponse,
  UnassignUserFromDeviceParams,
  UnassignUserFromDeviceResponse,
  TokenType
} from './types';

// === AUTH CONFIG TYPE ===
export type { AuthConfig } from '../auth/authUtils';

// === CONSTANTS ===
export {
  GROUP_API_ERROR_MESSAGES,
  GET_GROUP_LIST_ERROR_MESSAGES,
  DELETE_GROUP_ERROR_MESSAGES,
  RENAME_GROUP_ERROR_MESSAGES,
  ASSIGN_SUBMASTER_ERROR_MESSAGES,
  UNASSIGN_SUBMASTER_ERROR_MESSAGES,
  ADD_DEVICES_TO_GROUP_ERROR_MESSAGES,
  REMOVE_DEVICES_FROM_GROUP_ERROR_MESSAGES,
  GET_GROUP_DEVICES_ERROR_MESSAGES,
  GET_GROUP_USERS_ERROR_MESSAGES,
  ASSIGN_USER_TO_DEVICE_ERROR_MESSAGES,
  UNASSIGN_USER_FROM_DEVICE_ERROR_MESSAGES,
} from './types';

// === VERSION INFO ===
export const GROUP_API_VERSION = '1.0.0';
export const GROUP_API_NAME = 'FleetA Group Management API';